TS.ns('WL');
 
WL.partnerPersonConsents = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        consentList = me.getDomainProperty('grdDisplayedConsentCollection_Property');

        if (consentList) {
            consentList.on('cellValueChanged', me.onConsentValueChanged, me);

            consentList.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.content.children("table").children("tbody").children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row); 
                        var dcell = row.children().eq(7);
                        var daLink = dcell.children().children();
                        daLink.removeAttr("target");
                        daLink.attr("href", "javascript:TS.UI.models.peek().UploadToDMS(" + dataItem.ConsentTypeId + ")");
                        var cell = row.children().eq(8);
                        var aLink = cell.children().children();
                        aLink.removeAttr("target");  // framework bug workaround ERPARCHADF-283
                        if (dataItem.IsUploaded == false) {
                            aLink.attr("href", "#");
                            aLink.addClass("ts-command-disabled");
                        }
                        else {
                            aLink.attr("href", "javascript:TS.UI.models.peek().DownloadFromDMS(" + dataItem.ConsentTypeId + ")");
                        }
                    }
                }
            }

        }
    },
      
    onConsentValueChanged: function (e) {
        var me = this;

        me.performServerCommand({
            cmd: 'ConsentCheckValueChanged',
            submitModel: true,
            extraData: {
                ConsentTypeId: e.record.ConsentTypeId
            },
            blockUI: true
        });
    },

    UploadToDMS: function (e) {
        var me = this;


        me.performServerCommand({
            cmd: 'UploadDocument',
            submitModel: true,
            extraData: {
                ConsentTypeId: e
            },
            blockUI: true
        });
    },

    DownloadFromDMS: function (e) {
        var me = this;


        me.performServerCommand({
            cmd: 'DownloadDocument',
            submitModel: true,
            extraData: {
                ConsentTypeId: e
            },
            blockUI: true
        });
    }
});